module.exports = __webpack_public_path__ + "img/01.d4b662c1.jpg";